import uaParser from 'ua-parser-js';

const deviceInfo = uaParser(window.navigator.userAgent);

export const isMobileDevice = (() => {
  const isWindow = /window/i.test(deviceInfo.os.name);

  if (isWindow) {
    return false;
  } else {
    if (deviceInfo.device.type === 'mobile' || deviceInfo.device.type === 'tablet') {
      return true;
    } else {
      return window.navigator.maxTouchPoints > 0;
    }
  }
})();
